import React, { useContext } from "react";
import styled from "styled-components";

import { Dialog, DialogContent, Button } from "@material-ui/core";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const TEAL = "#00A896";
const TEAL_LIGHT = "#E0F2F1";

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 14px;
    max-width: 520px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }
`;

const Content = styled(DialogContent)`
  && {
    padding: 32px 28px 28px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 20px;
`;

const IconCircle = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${TEAL_LIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  color: ${TEAL};
  line-height: 1;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${TEAL};
`;

const BodyText = styled.p`
  margin: 0 0 14px;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #333333;

  strong {
    font-weight: 700;
  }
`;

const Hint = styled.p`
  margin: 8px 0 24px;
  font-size: 0.95rem;
  color: #333333;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const PrimaryBtnWrap = styled.div`
  width: 100%;
`;

const SecondaryBtnWrap = styled.div`
  width: auto;
  min-width: 140px;
`;

const TealButton = styled(Button)`
  && {
    background-color: ${TEAL};
    color: #fff;
    text-transform: none;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-size: 0.9rem;
    border-radius: 6px;
    padding: 10px 20px;
    box-shadow: none;

    &:hover {
      background-color: #008f7f;
      box-shadow: none;
    }
  }
`;

const TealButtonFull = styled(TealButton)`
  && {
    width: 100%;
  }
`;

const getDfeEmissorUrl = (currentUrl) => {
  const base =
    currentUrl !== "localhost"
      ? `https://${currentUrl}.qyon.com`
      : "http://localhost";
  return `${base}/zf/dfe`;
};

const ModalAvisoDescontinuacaoEmissaoNfe = ({ open, setOpen }) => {
  const { queryParams } = useContext(QueryParamsContext);

  const handleClose = () => setOpen(false);

  const handleAccessNewEmissor = () => {
    const url = getDfeEmissorUrl(queryParams.current_url);
    const link = document.createElement("a");
    link.href = url;
    link.target = "_top";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <StyledDialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
        handleClose();
      }}
      maxWidth="xs"
      fullWidth
      aria-labelledby="aviso-descontinuacao-nfe"
    >
      <Content>
        <TitleRow>
          <IconCircle aria-hidden>!</IconCircle>
          <Title id="aviso-descontinuacao-nfe">Atenção!</Title>
        </TitleRow>
        <BodyText>
          Esta tela de <strong>Emissão de NF-e e NFC-e</strong> será
          descontinuada no dia 01/08/2026.
        </BodyText>
        <BodyText>
          Já está disponível a nova tela de emissão, mais moderna e preparada
          para a <strong>Reforma Tributária</strong>, contemplando os novos
          campos fiscais.
        </BodyText>
        <BodyText>Recomendamos que comece a utilizá-la o quanto antes.</BodyText>
        <Hint>Clique abaixo para acessar:</Hint>
        <Actions>
          <PrimaryBtnWrap>
            <TealButtonFull
              variant="contained"
              onClick={handleAccessNewEmissor}
            >
              Acessar Emissor DF-e (Nova Nota Fiscal)
            </TealButtonFull>
          </PrimaryBtnWrap>
          <SecondaryBtnWrap>
            <TealButton variant="contained" onClick={handleClose}>
              Entendi
            </TealButton>
          </SecondaryBtnWrap>
        </Actions>
      </Content>
    </StyledDialog>
  );
};

export default ModalAvisoDescontinuacaoEmissaoNfe;
